
export enum DialogAction {
  Added, Updated, Deleted
}

export class DialogResult {
  action: DialogAction;
  ref: any;
}
